var map = {
	"./axj-web-auth-api.js": "/LiR",
	"./axj-web-index-api.js": "ARgO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mrUO";


//////////////////
// WEBPACK FOOTER
// ./src/api/axj-web -api.js$
// module id = mrUO
// module chunks = 1